import React from 'react';
import { renderToString } from 'react-dom/server';
import { Map, Marker, Popup, TileLayer, GeoJSON, AttributionControl } from 'react-leaflet';
import { GestureHandling } from "leaflet-gesture-handling";
import { getUrlParam } from './urlparams';
import { KreisPreview } from "./KreisPreview";
import L from 'leaflet';
// import ReactGA from 'react-ga';

export const pointerIcon = new L.divIcon({
    className: 'custom-div-icon z1000',
    html: "<div class='map-marker onlyMobil'></div>",
    iconSize: [16, 27],
    iconAnchor: [8, 27]
})

export class Coronakarte extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            popupPos: [0, 0],
            selected_kreis: null,
            can_hover: true,
        }

        this.popupRef = React.createRef();
        this.leafletMapRef = React.createRef();

        this.closePopoverTimeout = null

        this.getStyle = this.getStyle.bind(this);
        this.selectKreis = this.selectKreis.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.setToStartZoom = this.setToStartZoom.bind(this);
        this.handleZoomChange = this.handleZoomChange.bind(this);
    }

    closePopup() {
        this.props.selectKreis(null);
        this.setState({
            popupPos: [0, 0],
            selected_kreis: null,
            can_hover: true
        })
    }

    componentDidMount() {
        // Kalkuliere die optimale Zoomstufe und die Kartenmitte
        var bbox = require('geojson-bbox');
        let mapbox = bbox(this.props.geojson) // Berechnet die äußeren Koordinaten der Geojson

        const Erdradius = 6378137;

        function squared (x) { return x * x }
        function toRad (x) { return x * Math.PI / 180.0 }
        function hav (x) {return squared(Math.sin(x / 2))}

        function haversineDistance (a, b) {
            const aLat = toRad(a[1])
            const bLat = toRad(b[1])
            const aLng = toRad(a[0])
            const bLng = toRad(b[0])

            const ht = hav(bLat - aLat) + Math.cos(aLat) * Math.cos(bLat) * hav(bLng - aLng)
            return 2 * Erdradius * Math.asin(Math.sqrt(ht))
        }
        let northSouthDist = haversineDistance([mapbox[0], mapbox[1]], [mapbox[0], mapbox[3]])

        let zoom = 2;
        let mapHeigth = this.props.screenHeight;
        if (window.innerWidth < 750) {
            mapHeigth = this.props.screenHeight - 166;
        }
        for (let zoomLevel of [2,3,4,5,6,7,8,9,10,11,12,13,14]) {
            let metresPerPixel = 40075016.686 * Math.abs(Math.cos((mapbox[1] + mapbox[3]) / 2 * Math.PI/180)) / Math.pow(2, zoomLevel+8);

            if (mapHeigth * metresPerPixel > northSouthDist) {
                zoom = zoomLevel
            } else {
                break
            }
        }

        let center = [(mapbox[1] + mapbox[3]) / 2, (mapbox[0] + mapbox[2]) / 2]
        let metresPerPixel = 40075016.686 * Math.abs(Math.cos((mapbox[1] + mapbox[3]) / 2 * Math.PI/180)) / Math.pow(2, zoom+8);
        if (window.innerWidth < 750) {
            let coord_offset = (metresPerPixel * 20) / 111111
            center = [(mapbox[1] + mapbox[3]) / 2 + coord_offset, (mapbox[0] + mapbox[2]) / 2]
        }
        let bounds_offset = (metresPerPixel * 150) / 111111
        let maxBounds = [[mapbox[1] - bounds_offset, mapbox[0] - bounds_offset], [mapbox[3] + bounds_offset, mapbox[2] + bounds_offset]]

        this.setState({
            center: center,
            maxBounds: maxBounds,
            zoom: zoom
            //selected_date: this.props.selected_date
        })
    }

    getStyle(geoJsonFeature) {
        let BezirkStyle = {
            "color": "#EAEAEA",
            "weight": 0.6,
            "fillColor": "#ffffff",
            "fillOpacity": 1
        };
        if (this.props.selected_date in this.props.kreise[geoJsonFeature.properties.ags]) {
            let val = this.props.kreise[geoJsonFeature.properties.ags][this.props.selected_date].inzidenz;
            let range_end = this.props.max_inzidenz;

            // let color2 = [255, 248, 212];

            let color1 = [55, 17, 25];
            let color2 = [199, 74, 101];

            let offset = 50;
            // let color1 = [255, 255, 255];

            if (val < 50) {
                offset = 0;
                range_end = 50;
                color1 = [199, 74, 101];
                color2 = [255, 248, 212];
                // color1 = [255, 255, 255];
                // color2 = [255, 255, 255];
            }


            let w1 = (val - offset) / (range_end - offset);
            let w2 = 1 - w1;
            let rgb = [
                Math.round(color1[0] * w1 + color2[0] * w2),
                Math.round(color1[1] * w1 + color2[1] * w2),
                Math.round(color1[2] * w1 + color2[2] * w2)
            ];
            BezirkStyle.fillColor = 'rgb(' + rgb[0] + ', ' + rgb[1] + ', ' + rgb[2] + ')';
        } else {
            console.log('error', this.props.kreise[geoJsonFeature.properties.ags])
        }

        if (this.state.selected_kreis && this.state.selected_kreis.ags == geoJsonFeature.properties.ags) {
            BezirkStyle.weight = 7
        }

        return BezirkStyle;
    }

    setToStartZoom() {
        this.leafletMapRef.current.leafletElement.setZoom(this.state.zoom)
    }

    onEachFeature(feature, layer) {
        layer.on({
            click: this.clickToFeature.bind(this),
            mouseover: this.mouseoverFeature.bind(this),
            mouseout: this.mouseoutFeature.bind(this),
            mousemove: this.moveFeature.bind(this),
        });
    }

    mouseoverFeature(e) {
        if (!this.state.can_hover || window.innerWidth < 750) {
            return
        }
        let kreis = this.props.kreise[e.target.feature.properties.ags]
        if (this.closePopoverTimeout) {
            clearTimeout(this.closePopoverTimeout);
        }
        // this.popupRef.current.leafletElement.setContent(renderToString(
        //     <KreisPreview
        //         kreis={kreis}
        //         selected_date={this.props.selected_date}
        //     />
        // ))
        if (this.state.selected_kreis != kreis) {
            this.setState({selected_kreis: kreis})
            this.props.selectKreis(kreis)
        }

        e.target.setStyle({
            "weight": 7,
        })
        // ReactGA.event({
        //     category: 'Mouseover',
        //     action: (this.props.kreise[e.target.feature.properties.ags].city)
        // });
    }

    moveFeature(e) {
        if (!this.state.can_hover || window.innerWidth < 750) {
            return
        }

        let mouseX = e.containerPoint.x
        let mouseY = e.containerPoint.y

        this.calculatePopupOffset(mouseX, mouseY)

        this.setState({
            popupPos: e.latlng
        })

    }

    mouseoutFeature(e) {
        if (!this.state.can_hover || window.innerWidth < 750) {
            return
        }
        const self = this;
        self.closePopoverTimeout = setTimeout(function () {
            self.popupRef.current.leafletElement.setLatLng([0, 0])
            self.setState({selected_kreis: null})
            self.props.selectKreis(null)
        }, 200)


        e.target.setStyle({
            "weight": 1
        })
    }

    clickToFeature(e) {
        this.selectKreis(this.props.kreise[e.target.feature.properties.ags], e)
        // ReactGA.event({
        //     category: 'Click on Feature',
        //     action: (this.props.kreise[e.target.feature.properties.ags].city)
        // });
    }

    calculatePopupOffset(X, Y, fixed) {
        let popupHeight = this.popupRef.current.leafletElement._container.clientHeight
        let popupWidth = this.popupRef.current.leafletElement._container.clientWidth

        let popupOffset = this.popupRef.current.leafletElement.options.offset

        if (popupHeight < 100) {
            popupHeight = 250;
        }

        let newPopupOffsetX = 0
        let newPopupOffsetY = 0

        let arrowPos = "bottom"
        if (Y < popupHeight + 30) {
            arrowPos = "top"
        }

        if (Y < popupHeight + 30) {
            newPopupOffsetY = popupHeight + 65
        }

        if (popupWidth / 2 + X > window.innerWidth) {
            newPopupOffsetX = (-1) * (popupWidth / 2 - (window.innerWidth - X));
        } else if (X < popupWidth / 2) {
            newPopupOffsetX = popupWidth / 2 - X;
        }

        if (popupOffset != [newPopupOffsetX, newPopupOffsetY]) {
            this.popupRef.current.leafletElement.options.offset = [newPopupOffsetX, newPopupOffsetY]
        }

        if (fixed) {
            this.setState({arrowPos: arrowPos, arrowX: popupWidth / 2 + newPopupOffsetX})
        }
    }

    selectKreis(kreis, e, searchResClick) {
        this.props.selectKreis(kreis);

        let popupPos;
        if (e) {
            this.calculatePopupOffset(e.containerPoint.x, e.containerPoint.y, e)
            popupPos = e.latlng;
        } else {
            var bbox = require('geojson-bbox');
            let mapbox = null;
            for (const [key, value] of Object.entries(this.props.geojson.features)) {
                if (value.properties.ags == kreis.ags) {
                    mapbox = bbox(value) // Berechnet die äußeren Koordinaten der Geojson
                    break;
                }
            }

            let kreis_lat = (mapbox[1] + mapbox[3]) / 2;
            let kreis_lon = (mapbox[0] + mapbox[2]) / 2;

            let projected = this.leafletMapRef.current.leafletElement.latLngToLayerPoint([kreis_lat, kreis_lon])
            let containerPoint = this.leafletMapRef.current.leafletElement.layerPointToContainerPoint(projected);

            if(searchResClick) {
                this.calculatePopupOffset(containerPoint.x, containerPoint.y, true)
            } else {
                this.calculatePopupOffset(containerPoint.x, containerPoint.y)
            }

            popupPos = [kreis_lat, kreis_lon]
        }


        this.setState({
            popupPos: popupPos,
            selected_kreis: kreis,
            can_hover: false
        })
    }

    handleZoomChange(e) {
        if ((e.target._zoom >= 7 && this.state.zoom < 7)
            || (e.target._zoom < 7 && this.state.zoom >= 7)) {
            this.setState({zoom: e.target._zoom})
        }
    }


    render() {
        if (!this.state.center) {
            return null;
        }
        return (

            <Map
                ref={this.leafletMapRef}
                zoom={this.state.zoom}
                minZoom={this.state.zoom - 2}
                center={this.state.center}
                maxBounds={this.state.maxBounds}
                preferCanvas={true}
                addInitHooks={"addHandler", "gestureHandling", GestureHandling}
                gestureHandling={getUrlParam('gestureHandling')}
                gestureHandlingOptions={{
                    duration: 1000,
                    text: {
                        touch: "Verwenden Sie zwei Finger, um die Karte zu bewegen",
                        scroll: "Verwenden Sie Strg + Scrollen zum Zoomen der Karte",
                        scrollMac: "Verwenden Sie \u2318 + Scrollen zum Zoomen der Karte"
                    }
                }}
                attributionControl={false}
                style={{
                    height: this.props.screenHeight.toString() + 'px'
                }}
                onZoomEnd={this.handleZoomChange}
            >
                {this.state.selected_kreis && !(this.state.can_hover) &&
                    <Marker
                        position={this.state.popupPos}
                        icon={pointerIcon}
                        className="z401"
                    >
                    </Marker>
                }
                {this.props.stadtlabels && (this.props.map !== 'Deutschland' || this.props.city_stadtlabels) &&
                (this.props.map === 'Deutschland' && this.state.zoom >= 7
                        ?
                        this.props.city_stadtlabels.map((label, index) => (
                            <Marker
                                position={[label.geometry.coordinates[1], label.geometry.coordinates[0]]}
                                icon={this.props.city_stadtMarker[index]}
                            >
                            </Marker>
                        ))
                        :
                        this.props.stadtlabels.map((label, index) => (
                            <Marker
                                position={[label.geometry.coordinates[1], label.geometry.coordinates[0]]}
                                icon={this.props.stadtMarker[index]}
                            >
                            </Marker>
                        ))
                )
                }
                <Popup
                    position={this.state.popupPos}
                    ref={this.popupRef}
                    autoPan={false}
                    closeOnClick={false}
                    className={this.state.can_hover ? "pointer-events-0" : ""}
                >
                    <KreisPreview
                        kreis={this.state.selected_kreis}
                        selected_date={this.props.selected_date}
                        showCloseIcon={this.state.can_hover ? false : true}
                        closePopup={this.closePopup.bind(this)}
                        arrowPos={this.state.arrowPos}
                        arrowX={this.state.arrowX}
                    />
                </Popup>
                <AttributionControl
                    position="bottomright"
                    prefix="<a href='https://leafletjs.com/' target='_blank'>Leaflet</a> | Daten: <a href='https://experience.arcgis.com/experience/478220a4c454480e823b17327b2bf1d4' target='_blank'>Robert-Koch-Institut</a>"
                />
                <GeoJSON
                    ref={this.geojsonLayerRef}
                    key='features'
                    data={this.props.geojson}
                    style={this.getStyle}
                    onEachFeature={this.onEachFeature.bind(this)}
                    // attribution={this.state.mobileScreen
                    //     ? 'Quelle: ' + (this.state.city == 'NRW' ? 'Landeswahlleiter NRW' : 'Wahlamt ' + this.state.city)
                    //     : '<span class="mobile-0">Von <a href="https://twitter.com/boissereec" target="_blank">Clemens Boisserée</a>, <a href="https://twitter.com/philninh" target="_blank">Phil Ninh</a> und <a href="https://twitter.com/Matth_Meyer" target="_blank">Matthias Meyer</a></span> | Quelle: ' + (this.state.city == 'NRW' ? 'Landeswahlleiter NRW' : 'Wahlamt ' + this.state.city)
                    // }
                />
            </Map>
        )

    }
}